var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 42.5",
    style: {
      enableBackground: "new 0 0 39.7 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2,21.8l7.8,7.8c1.6,1.6,3.2,3.2,4.8,4.8c0.9,0.6,1,1.8,0.4,2.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.2-2.4,2.4-3.6,3.6 c-0.6,0.8-1.7,0.9-2.5,0.3c-0.1-0.1-0.1-0.2-0.2-0.3L7.8,23.1c-0.8-0.5-1-1.6-0.5-2.3c0.1-0.2,0.3-0.3,0.5-0.5 c5.9-5.9,11.8-11.8,17.8-17.7c0.6-0.8,1.7-0.9,2.4-0.3c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.2,2.3,2.3,3.5,3.5s1,2,0,3 c-3.9,4-7.9,7.9-11.9,11.9C19.7,21.3,19.5,21.5,19.2,21.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.dba03d15bb1ecf664d81c213b91c5fb5.svg";
export { ForwardRef as ReactComponent };